export default "__VITE_ASSET__De$6FbdX__"